//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { subscribePromoPages } from '@/helpers/subscribePromo.js';

export default {
  name: 'SubscriptionPromoPage',
  components: {
    UnactivatedAccountFlash: () => import('@motionelements/core/src/components/account/UnactivatedAccountFlash.vue'),
    SubscribePromoHero: () => import('@/components/subscribe-promo/SubscribePromoHero.vue'),
    SubscribePromoBenefits: () => import('@/components/subscribe-promo/SubscribePromoBenefits.vue'),
    SubscribePromoSteps: () => import('@/components/subscribe-promo/SubscribePromoSteps.vue'),
    FussFreeLicensing: () => import('@/components/subscribe/FussFreeLicensing.vue'),
    SubscribeCurations: () => import('@/components/subscribe/SubscribeCurations.vue'),
    SubscribePromoReady: () => import('@/components/subscribe-promo/SubscribePromoReady.vue'),
    HomeLicensing: () => import('@/components/home-page/HomeLicensing.vue'),
    HomePartners: () => import('@/components/home-page/HomePartners.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
  },
  async asyncData({ params, redirect }) {
    const promoPage = subscribePromoPages.find(({ id }) => id.includes(params.id));
    if (promoPage) {
      const name = promoPage.name;
      const videoUrl = promoPage.videoUrl;
      // const planId = promoPage.planId;
      const couponCode = promoPage.couponCode;

      return {
        name,
        videoUrl,
        // planId,
        couponCode,
      };
    }
    redirect('/');
  },
  data() {
    return {
      discountPercent: 70,
    };
  },
  computed: {
    ...mapGetters({
      userCurrency: 'user/currencyCode',
      getPlanBilledMonthly: 'subscription/getPlanBilledMonthly',
    }),
    pageOgImage() {
      const languageSuffix = ['en', 'ja', 'ko', 'zh-hant'].includes(this.$i18n.locale) ? this.$i18n.locale : 'en';
      return `https://static.moele.me/img/subscribe/subscription-og-${languageSuffix}.220830.jpg`;
    },
    subscribePlanLink() {
      return this.$link('/subscribe/payment').param('plan', this.planId).param('coupon', this.couponCode).url();
    },
    planId() {
      return this.getPlanBilledMonthly?.id || '';
    },
  },
  watch: {
    userCurrency: { // @toDo @Pavlo why we need to watch userCurrency and resend getPlans
      handler(toCurrencyCode) {
        if (toCurrencyCode) {
          this.$store.dispatch('subscription/getPlans');
        }
      },
      immediate: true,
    },
  },
};
